import { render, staticRenderFns } from "./purschemedetailview.vue?vue&type=template&id=a24ccc48&scoped=true&"
import script from "./purschemedetailview.vue?vue&type=script&lang=js&"
export * from "./purschemedetailview.vue?vue&type=script&lang=js&"
import style0 from "./purschemedetailview.vue?vue&type=style&index=0&id=a24ccc48&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a24ccc48",
  null
  
)

export default component.exports